import type { FilterConfig } from '@/types/filters.types';

/**
 * Filter keys MUST match the canonical legacy filter registry.
 * DO NOT rename keys or change option values — dynamic lists store these permanently.
 * See lib/filterRegistry.ts for the full registry and rules.
 */
export const APPOINTMENT_FILTER_CONFIGS: FilterConfig[] = [
  { key: 'search', label: 'Search', type: 'search', allLabel: 'Search appointments...' },
  { key: 'daterange', label: 'Date', type: 'daterange' },
  { key: 'appointment-status', label: 'Status', type: 'select', allLabel: 'All statuses', multi: true },
  { key: 'facility', label: 'Facility', type: 'select', allLabel: 'All facilities', multi: true },
  { key: 'doctor', label: 'Provider', type: 'select', allLabel: 'All providers', multi: true },
  // Two-layer category → type picker, same shape as the Payments product
  // filter: `collapsibleGroups` WITHOUT `groupSelect`, so a category header
  // only ticks the types beneath it and is never itself a stored value. The
  // saved filter stays a plain list of appointmentTypeIDs.
  { key: 'appt-type', label: 'Type', type: 'select', allLabel: 'All types', multi: true, searchable: true, collapsibleGroups: true },
  { key: 'member-status', label: 'Membership', type: 'select', allLabel: 'All patients', multi: true },
  { key: 'other', label: 'Other', type: 'select', allLabel: 'All', multi: true },
];
